import { Component } from 'react';
import PropTypes from 'prop-types';

import { onRecaptchaLoaded } from '~/middlewares/recaptcha';

export default class ReCAPTCHAv2 extends Component {
  static propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    siteKey: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(['light', 'dark']),
  };

  static defaultProps = {
    className: '',
    theme: 'light',
  };

  componentDidMount() {
    onRecaptchaLoaded(() => {
      window.grecaptcha.enterprise.render(this.el, {
        sitekey: this.props.siteKey,
        theme: this.props.theme || 'light',
        callback: this.props.onChange,
      });
    });
  }

  render() {
    return (
      <div
        className={this.props.className}
        ref={(el) => {
          this.el = el;
        }}
      />
    );
  }
}
